import React from "react"
export function UpChevron(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__up-chevron"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M9.48 6.21a.75.75 0 01.948-.076l.091.075 6.981 6.717L16.461 14 10 7.783 3.54 14 2.5 12.926 9.48 6.21z"
          id="prefix__up"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
